module.exports = __webpack_public_path__ + "img/銀徽章.c93466b1.svg";